var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"tsw-weixin-guide-mask weixin-guide-container",on:{"touchmove":function($event){$event.preventDefault();},"click":_vm.showGuide}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }